// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button__container-d6909c {
  --button-text-left-offset: 4px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  color: var(--color);
  background-color: var(--background-color);
  border: var(--border);
  text-decoration: none;
  padding: 0 var(--button-side-offset) 0 calc(var(--button-side-offset) - var(--button-text-left-offset));
  height: var(--button-height);
  min-width: var(--button-min-width);
  font: var(--button-font);
  letter-spacing: var(--button-letter-spacing);
  border-radius: var(--button-border-radius);
}

.Button__container-d6909c:hover,
.Button__container-d6909c.Button__active-e40b20 {
  color: var(--color-hover);
  background-color: var(--background-color-hover);
}

@supports (display: block) {
  .Button__container-d6909c:focus-visible {
    color: var(--color-focus);
    background-color: var(--background-color-focus);
  }
}
.Button__container-d6909c:focus-within {
  color: var(--color-focus);
  background-color: var(--background-color-focus);
}

.Button__container-d6909c:active {
  color: var(--color-active);
  background-color: var(--background-color-active);
}

.Button__container-d6909c:disabled {
  color: var(--color-disabled);
  background-color: var(--background-color-disabled);
  cursor: default;
  border: var(--border-disabled);
}

.Button__content-f4023e {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.Button__text-a949db {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-inline-start: var(--button-text-left-offset);
}

.Button__hidden-e31799 {
  visibility: hidden;
}

.Button__container-d6909c .Button__loader-c30a1e {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  margin-inline-start: -8px;
  margin-top: -8px;
  color: var(--color);
}

.Button__icon-c31062 {
  fill: currentColor;
  margin-inline-end: 4px;
  flex: 0 0 auto;
}

.Button__size-0-c8f66c,
.Button__size-0-c8f66c.Button__rounding-0-f8cb83 {
  --button-border-radius: 16px;
}

.Button__size-10-af089e,
.Button__size-10-af089e.Button__rounding-0-f8cb83 {
  --button-border-radius: 20px;
}

.Button__size-20-b66d4e,
.Button__size-20-b66d4e.Button__rounding-0-f8cb83 {
  --button-border-radius: 24px;
}

.Button__size-30-f6a678,
.Button__size-30-f6a678.Button__rounding-0-f8cb83 {
  --button-border-radius: 25px;
}

.Button__size-0-c8f66c.Button__rounding-1-bfe0c5 {
  --button-border-radius: 8px;
}

.Button__size-10-af089e.Button__rounding-1-bfe0c5,
.Button__size-20-b66d4e.Button__rounding-1-bfe0c5,
.Button__size-30-f6a678.Button__rounding-1-bfe0c5 {
  --button-border-radius: 12px;
}

.Button__size-0-c8f66c.Button__rounding-2-d7a7d7,
.Button__size-10-af089e.Button__rounding-2-d7a7d7,
.Button__size-20-b66d4e.Button__rounding-2-d7a7d7,
.Button__size-30-f6a678.Button__rounding-2-d7a7d7 {
  --button-border-radius: 4px;
}

.Button__size-0-c8f66c {
  --button-side-offset: 12px;
  --button-min-width: 64px;
  --button-height: 32px;
  --button-font: var(--font-button);
  --button-letter-spacing: var(--font-spacing-button);
}

.Button__size-10-af089e {
  --button-side-offset: 16px;
  --button-min-width: 88px;
  --button-height: 40px;
  --button-font: var(--font-body-2);
  --button-letter-spacing: var(--font-spacing-body-2);
}

.Button__size-20-b66d4e,
.Button__size-30-f6a678 {
  --button-side-offset: 24px;
  --button-min-width: 96px;
  --button-font: var(--font-body-2);
  --button-letter-spacing: var(--font-spacing-body-2);
}

.Button__size-20-b66d4e {
  --button-height: 48px;
}

.Button__size-30-f6a678 {
  --button-height: 52px;
}

.Button__theme-primary-e584ed {
  --color: var(--addition-50);
  --background-color: var(--brand-primary-40);
  --border: none;
  --color-hover: var(--addition-50);
  --background-color-hover: var(--brand-primary-50);
  --color-focus: var(--addition-50);
  --background-color-focus: var(--brand-primary-50);
  --color-active: var(--addition-50);
  --background-color-active: var(--brand-primary-60);
  --color-disabled: var(--addition-60);
  --background-color-disabled: var(--brand-primary-20);
  --border-disabled: none;
}

.Button__theme-secondary-f3364d {
  --color: var(--base-100);
  --background-color: var(--base-20);
  --border: none;
  --color-hover: var(--base-100);
  --background-color-hover: var(--base-30);
  --color-focus: var(--base-100);
  --background-color-focus: var(--base-30);
  --color-active: var(--base-100);
  --background-color-active: var(--base-40);
  --color-disabled: var(--base-60);
  --background-color-disabled: var(--base-20);
  --border-disabled: none;
}

.Button__theme-text-primary-e07c38 {
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --border: none;
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--brand-primary-0);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--brand-primary-0);
  --color-active: var(--brand-primary-40);
  --background-color-active: var(--brand-primary-10);
  --color-disabled: var(--brand-primary-20);
  --background-color-disabled: transparent;
  --border-disabled: none;
}

.Button__theme-text-thirty-fb150a {
  --color: var(--brand-secondary-40);
  --color-hover: var(--brand-secondary-40);
  --color-focus: var(--brand-secondary-40);
  --color-active: var(--brand-secondary-40);
  --color-disabled: var(--brand-secondary-20);
  --background-color: transparent;
  --background-color-hover: var(--brand-secondary-0);
  --background-color-focus: var(--brand-secondary-0);
  --background-color-active: var(--brand-secondary-10);
  --background-color-disabled: transparent;
}

.Button__theme-text-error-ae34b3 {
  --color: var(--danger-40);
  --background-color: transparent;
  --border: none;
  --color-hover: var(--danger-40);
  --background-color-hover: var(--danger-0);
  --color-focus: var(--danger-40);
  --background-color-focus: var(--danger-0);
  --color-active: var(--danger-40);
  --background-color-active: var(--danger-10);
  --color-disabled: var(--danger-30);
  --background-color-disabled: transparent;
  --border-disabled: none;
}

.Button__theme-text-secondary-ec4eb8 {
  --color: var(--base-110);
  --background-color: transparent;
  --border: none;
  --color-hover: var(--base-110);
  --background-color-hover: var(--base-20);
  --color-focus: var(--base-110);
  --background-color-focus: var(--base-20);
  --color-active: var(--base-110);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-60);
  --background-color-disabled: transparent;
  --border-disabled: none;
}

.Button__theme-outline-primary-ec3b0b {
  --color: var(--brand-primary-40);
  --background-color: transparent;
  --border: 1px solid var(--brand-primary-40);
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--brand-primary-0);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--brand-primary-0);
  --color-active: var(--brand-primary-40);
  --background-color-active: var(--brand-primary-10);
  --color-disabled: var(--brand-primary-20);
  --background-color-disabled: transparent;
  --border-disabled: 1px solid var(--brand-primary-10);
}

.Button__theme-primary-light-babd7e {
  --color: var(--brand-primary-40);
  --background-color: var(--brand-primary-10);
  --border: none;
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--brand-primary-10);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--brand-primary-10);
  --color-active: var(--brand-primary-40);
  --background-color-active: var(--brand-primary-20);
  --color-disabled: var(--brand-primary-40);
  --background-color-disabled: var(--brand-primary-10);
  --border-disabled: none;
}

/*number of theme should be synced with design*/
.Button__theme-10-ebc487 {
  --color: var(--addition-50);
  --color-hover: var(--addition-50);
  --color-focus: var(--addition-50);
  --color-active: var(--addition-50);
  --color-disabled: var(--addition-50);
  --background-color: var(--success-40);
  --background-color-hover: var(--success-50);
  --background-color-focus: var(--success-50);
  --background-color-active: var(--success-60);
  --background-color-disabled: var(--success-10);
}

.Button__theme-fixed-color-e4c76b {
  --color: var(--addition-50);
  --background-color: var(--addition-110_70);
  --border: none;
  --color-hover: var(--addition-50);
  --background-color-hover: var(--addition-110_80);
  --color-focus: var(--addition-50);
  --background-color-focus: var(--addition-110_80);
  --color-active: var(--addition-50);
  --background-color-active: var(--addition-110_95);
  --color-disabled: var(--addition-50_50);
  --background-color-disabled: var(--addition-110_70);
  --border-disabled: none;
}

.Button__theme-13-e00d43 {
  --color: var(--addition-80);
  --background-color: var(--addition-50);
  --border: none;
  --color-hover: var(--addition-80_90);
  --background-color-hover: var(--addition-50);
  --color-focus: var(--addition-80_90);
  --background-color-focus: var(--addition-50);
  --color-active: var(--addition-80_70);
  --background-color-active: var(--addition-50);
  --color-disabled: var(--addition-80_70);
  --background-color-disabled: var(--addition-50_50);
  --border-disabled: none;
}

.Button__theme-primary-white-d21383 {
  --color: var(--brand-primary-40);
  --background-color: var(--addition-50);
  --border: none;
  --color-hover: var(--brand-primary-40);
  --background-color-hover: var(--addition-50);
  --color-focus: var(--brand-primary-40);
  --background-color-focus: var(--addition-50);
  --color-active: var(--brand-primary-40);
  --background-color-active: var(--addition-50);
  --color-disabled: var(--brand-primary-40_50);
  --background-color-disabled: var(--addition-50_50);
  --border-disabled: none;
}

.Button__theme-secondary-white-ef8b1f {
  --background-color-action: color-mix(in srgb, var(--addition-40) 10%, var(--addition-50));
  --color: var(--addition-40);
  --background-color: var(--addition-50);
  --border: none;
  --color-hover: var(--addition-40);
  --background-color-hover: var(--background-color-action);
  --color-focus: var(--addition-40);
  --background-color-focus: var(--background-color-action);
  --color-active: var(--addition-40);
  --background-color-active: var(--background-color-action);
  --color-disabled: var(--addition-40_50);
  --background-color-disabled: var(--addition-50_50);
  --border-disabled: none;
}

.Button__theme-16-fd1908 {
  --color: var(--base-100);
  --background-color: var(--addition-70);
  --border: 2px solid var(--base-30);
  --color-hover: var(--base-100);
  --background-color-hover: var(--addition-140);
  --color-focus: var(--base-100);
  --background-color-focus: var(--addition-140);
  --color-active: var(--base-100);
  --background-color-active: var(--base-30);
  --color-disabled: var(--base-60);
  --background-color-disabled: transparent;
  --border-disabled: 2px solid var(--base-30);
}

/* synced with design CustomButton kind */
.Button__container-d6909c.Button__theme-primary-text-f066dd {
  --button-height: auto;
  --button-side-offset: 0;
  --button-text-left-offset: 0;
  --border: none;
  --border-disabled: none;
  --button-border-radius: 0;
  --color: var(--brand-primary-40);
  --color-hover: var(--brand-primary-50);
  --color-focus: var(--brand-primary-50);
  --color-active: var(--brand-primary-60);
  --color-disabled: var(--brand-primary-20);
  --background-color: transparent;
  --background-color-hover: transparent;
  --background-color-focus: transparent;
  --background-color-active: transparent;
  --background-color-disabled: transparent;
}

.Button__container-d6909c.Button__theme-fixed-icon-cfb373 {
  --border: 2px solid var(--base-30);
  --button-text-left-offset: 0px;
  --border-disabled: 2px solid var(--base-30);
  --color: var(--base-120);
  --color-hover: var(--base-120);
  --color-focus: var(--base-120);
  --color-active: var(--base-120);
  --color-disabled: var(--base-60);
  --background-color: transparent;
  --background-color-hover: var(--base-15);
  --background-color-focus: var(--base-30);
  --background-color-active: var(--base-30);
  --background-color-disabled: transparent;
  width: 100%;
  padding-inline-end: calc(var(--button-text-left-offset) + 24px);
}

.Button__container-d6909c.Button__theme-fixed-icon-cfb373.Button__size-20-b66d4e {
  --button-side-offset: 12px;
}

.Button__container-d6909c.Button__theme-fixed-icon-cfb373 .Button__content-f4023e {
  width: 100%;
  justify-content: space-between;
  text-align: center;
}

.Button__container-d6909c.Button__theme-fixed-icon-cfb373 .Button__text-a949db {
  flex: 1;
}

.Button__container-d6909c.Button__theme-fixed-icon-cfb373 .Button__icon-c31062 {
  fill: currentColor;
  margin-inline-end: 0;
  width: 24px;
}

.Button__container-d6909c:disabled.Button__theme-primary-light-babd7e {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Button/Button.styles.m.css"],"names":[],"mappings":"AAAA;EACE,8BAAA;EAEA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,yCAAA;EACA,qBAAA;EACA,qBAAA;EACA,uGAAA;EAEA,4BAAA;EACA,kCAAA;EACA,wBAAA;EACA,4CAAA;EACA,0CAAA;AAFF;;AAKA;;EAEE,yBAAA;EACA,+CAAA;AAFF;;AAKA;EACE;IACE,yBAAA;IACA,+CAAA;EAFF;AACF;AAKA;EACE,yBAAA;EACA,+CAAA;AAHF;;AAMA;EACE,0BAAA;EACA,gDAAA;AAHF;;AAMA;EACE,4BAAA;EACA,kDAAA;EACA,eAAA;EACA,8BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oDAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,sBAAA;EACA,cAAA;AAHF;;AAMA;;EAEE,4BAAA;AAHF;;AAMA;;EAEE,4BAAA;AAHF;;AAMA;;EAEE,4BAAA;AAHF;;AAMA;;EAEE,4BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;;;EAGE,4BAAA;AAHF;;AAMA;;;;EAIE,2BAAA;AAHF;;AAMA;EACE,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,iCAAA;EACA,mDAAA;AAHF;;AAMA;EACE,0BAAA;EACA,wBAAA;EACA,qBAAA;EACA,iCAAA;EACA,mDAAA;AAHF;;AAMA;;EAEE,0BAAA;EACA,wBAAA;EACA,iCAAA;EACA,mDAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,qBAAA;AAHF;;AAMA;EACE,2BAAA;EACA,2CAAA;EACA,cAAA;EACA,iCAAA;EACA,iDAAA;EACA,iCAAA;EACA,iDAAA;EACA,kCAAA;EACA,kDAAA;EACA,oCAAA;EACA,oDAAA;EACA,uBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,kCAAA;EACA,cAAA;EACA,8BAAA;EACA,wCAAA;EACA,8BAAA;EACA,wCAAA;EACA,+BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,uBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,+BAAA;EACA,cAAA;EACA,sCAAA;EACA,gDAAA;EACA,sCAAA;EACA,gDAAA;EACA,uCAAA;EACA,kDAAA;EACA,yCAAA;EACA,wCAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kCAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,2CAAA;EACA,+BAAA;EACA,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,wCAAA;AAHF;;AAMA;EACE,yBAAA;EACA,+BAAA;EACA,cAAA;EACA,+BAAA;EACA,yCAAA;EACA,+BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,kCAAA;EACA,wCAAA;EACA,uBAAA;AAHF;;AAMA;EACE,wBAAA;EACA,+BAAA;EACA,cAAA;EACA,8BAAA;EACA,wCAAA;EACA,8BAAA;EACA,wCAAA;EACA,+BAAA;EACA,yCAAA;EACA,gCAAA;EACA,wCAAA;EACA,uBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,+BAAA;EACA,2CAAA;EACA,sCAAA;EACA,gDAAA;EACA,sCAAA;EACA,gDAAA;EACA,uCAAA;EACA,kDAAA;EACA,yCAAA;EACA,wCAAA;EACA,oDAAA;AAHF;;AAMA;EACE,gCAAA;EACA,2CAAA;EACA,cAAA;EACA,sCAAA;EACA,iDAAA;EACA,sCAAA;EACA,iDAAA;EACA,uCAAA;EACA,kDAAA;EACA,yCAAA;EACA,oDAAA;EACA,uBAAA;AAHF;;AAMA,+CAAA;AACA;EACE,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,kCAAA;EACA,oCAAA;EACA,qCAAA;EACA,2CAAA;EACA,2CAAA;EACA,4CAAA;EACA,8CAAA;AAHF;;AAMA;EACE,2BAAA;EACA,0CAAA;EACA,cAAA;EACA,iCAAA;EACA,gDAAA;EACA,iCAAA;EACA,gDAAA;EACA,kCAAA;EACA,iDAAA;EACA,uCAAA;EACA,mDAAA;EACA,uBAAA;AAHF;;AAMA;EACE,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,oCAAA;EACA,4CAAA;EACA,oCAAA;EACA,4CAAA;EACA,qCAAA;EACA,6CAAA;EACA,uCAAA;EACA,kDAAA;EACA,uBAAA;AAHF;;AAMA;EACE,gCAAA;EACA,sCAAA;EACA,cAAA;EACA,sCAAA;EACA,4CAAA;EACA,sCAAA;EACA,4CAAA;EACA,uCAAA;EACA,6CAAA;EACA,4CAAA;EACA,kDAAA;EACA,uBAAA;AAHF;;AAMA;EACE,yFAAA;EAEA,2BAAA;EACA,sCAAA;EACA,cAAA;EACA,iCAAA;EACA,wDAAA;EACA,iCAAA;EACA,wDAAA;EACA,kCAAA;EACA,yDAAA;EACA,uCAAA;EACA,kDAAA;EACA,uBAAA;AAJF;;AAOA;EACE,wBAAA;EACA,sCAAA;EACA,kCAAA;EACA,8BAAA;EACA,6CAAA;EACA,8BAAA;EACA,6CAAA;EACA,+BAAA;EACA,yCAAA;EACA,gCAAA;EACA,wCAAA;EACA,2CAAA;AAJF;;AAOA,yCAAA;AACA;EACE,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EAEA,gCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,yCAAA;EAEA,+BAAA;EACA,qCAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;AANF;;AASA;EACE,kCAAA;EACA,8BAAA;EACA,2CAAA;EAEA,wBAAA;EACA,8BAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EAEA,+BAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,wCAAA;EAEA,WAAA;EACA,+DAAA;AATF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,WAAA;EACA,8BAAA;EACA,kBAAA;AATF;;AAYA;EACE,OAAA;AATF;;AAYA;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;AATF;;AAYA;EACE,YAAA;AATF","sourcesContent":[".container {\n  --button-text-left-offset: 4px;\n\n  cursor: pointer;\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n\n  color: var(--color);\n  background-color: var(--background-color);\n  border: var(--border);\n  text-decoration: none;\n  padding: 0 var(--button-side-offset) 0\n    calc(var(--button-side-offset) - var(--button-text-left-offset));\n  height: var(--button-height);\n  min-width: var(--button-min-width);\n  font: var(--button-font);\n  letter-spacing: var(--button-letter-spacing);\n  border-radius: var(--button-border-radius);\n}\n\n.container:hover,\n.container.active {\n  color: var(--color-hover);\n  background-color: var(--background-color-hover);\n}\n\n@supports (display: block) {\n  .container:focus-visible {\n    color: var(--color-focus);\n    background-color: var(--background-color-focus);\n  }\n}\n\n.container:focus-within {\n  color: var(--color-focus);\n  background-color: var(--background-color-focus);\n}\n\n.container:active {\n  color: var(--color-active);\n  background-color: var(--background-color-active);\n}\n\n.container:disabled {\n  color: var(--color-disabled);\n  background-color: var(--background-color-disabled);\n  cursor: default;\n  border: var(--border-disabled);\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.text {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  padding-inline-start: var(--button-text-left-offset);\n}\n\n.hidden {\n  visibility: hidden;\n}\n\n.container .loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  z-index: 1;\n  margin-inline-start: -8px;\n  margin-top: -8px;\n  color: var(--color);\n}\n\n.icon {\n  fill: currentColor;\n  margin-inline-end: 4px;\n  flex: 0 0 auto;\n}\n\n.size-0,\n.size-0.rounding-0 {\n  --button-border-radius: 16px;\n}\n\n.size-10,\n.size-10.rounding-0 {\n  --button-border-radius: 20px;\n}\n\n.size-20,\n.size-20.rounding-0 {\n  --button-border-radius: 24px;\n}\n\n.size-30,\n.size-30.rounding-0 {\n  --button-border-radius: 25px;\n}\n\n.size-0.rounding-1 {\n  --button-border-radius: 8px;\n}\n\n.size-10.rounding-1,\n.size-20.rounding-1,\n.size-30.rounding-1 {\n  --button-border-radius: 12px;\n}\n\n.size-0.rounding-2,\n.size-10.rounding-2,\n.size-20.rounding-2,\n.size-30.rounding-2 {\n  --button-border-radius: 4px;\n}\n\n.size-0 {\n  --button-side-offset: 12px;\n  --button-min-width: 64px;\n  --button-height: 32px;\n  --button-font: var(--font-button);\n  --button-letter-spacing: var(--font-spacing-button);\n}\n\n.size-10 {\n  --button-side-offset: 16px;\n  --button-min-width: 88px;\n  --button-height: 40px;\n  --button-font: var(--font-body-2);\n  --button-letter-spacing: var(--font-spacing-body-2);\n}\n\n.size-20,\n.size-30 {\n  --button-side-offset: 24px;\n  --button-min-width: 96px;\n  --button-font: var(--font-body-2);\n  --button-letter-spacing: var(--font-spacing-body-2);\n}\n\n.size-20 {\n  --button-height: 48px;\n}\n\n.size-30 {\n  --button-height: 52px;\n}\n\n.theme-primary {\n  --color: var(--addition-50);\n  --background-color: var(--brand-primary-40);\n  --border: none;\n  --color-hover: var(--addition-50);\n  --background-color-hover: var(--brand-primary-50);\n  --color-focus: var(--addition-50);\n  --background-color-focus: var(--brand-primary-50);\n  --color-active: var(--addition-50);\n  --background-color-active: var(--brand-primary-60);\n  --color-disabled: var(--addition-60);\n  --background-color-disabled: var(--brand-primary-20);\n  --border-disabled: none;\n}\n\n.theme-secondary {\n  --color: var(--base-100);\n  --background-color: var(--base-20);\n  --border: none;\n  --color-hover: var(--base-100);\n  --background-color-hover: var(--base-30);\n  --color-focus: var(--base-100);\n  --background-color-focus: var(--base-30);\n  --color-active: var(--base-100);\n  --background-color-active: var(--base-40);\n  --color-disabled: var(--base-60);\n  --background-color-disabled: var(--base-20);\n  --border-disabled: none;\n}\n\n.theme-text-primary {\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n  --border: none;\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--brand-primary-0);\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--brand-primary-0);\n  --color-active: var(--brand-primary-40);\n  --background-color-active: var(--brand-primary-10);\n  --color-disabled: var(--brand-primary-20);\n  --background-color-disabled: transparent;\n  --border-disabled: none;\n}\n\n.theme-text-thirty {\n  --color: var(--brand-secondary-40);\n  --color-hover: var(--brand-secondary-40);\n  --color-focus: var(--brand-secondary-40);\n  --color-active: var(--brand-secondary-40);\n  --color-disabled: var(--brand-secondary-20);\n  --background-color: transparent;\n  --background-color-hover: var(--brand-secondary-0);\n  --background-color-focus: var(--brand-secondary-0);\n  --background-color-active: var(--brand-secondary-10);\n  --background-color-disabled: transparent;\n}\n\n.theme-text-error {\n  --color: var(--danger-40);\n  --background-color: transparent;\n  --border: none;\n  --color-hover: var(--danger-40);\n  --background-color-hover: var(--danger-0);\n  --color-focus: var(--danger-40);\n  --background-color-focus: var(--danger-0);\n  --color-active: var(--danger-40);\n  --background-color-active: var(--danger-10);\n  --color-disabled: var(--danger-30);\n  --background-color-disabled: transparent;\n  --border-disabled: none;\n}\n\n.theme-text-secondary {\n  --color: var(--base-110);\n  --background-color: transparent;\n  --border: none;\n  --color-hover: var(--base-110);\n  --background-color-hover: var(--base-20);\n  --color-focus: var(--base-110);\n  --background-color-focus: var(--base-20);\n  --color-active: var(--base-110);\n  --background-color-active: var(--base-30);\n  --color-disabled: var(--base-60);\n  --background-color-disabled: transparent;\n  --border-disabled: none;\n}\n\n.theme-outline-primary {\n  --color: var(--brand-primary-40);\n  --background-color: transparent;\n  --border: 1px solid var(--brand-primary-40);\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--brand-primary-0);\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--brand-primary-0);\n  --color-active: var(--brand-primary-40);\n  --background-color-active: var(--brand-primary-10);\n  --color-disabled: var(--brand-primary-20);\n  --background-color-disabled: transparent;\n  --border-disabled: 1px solid var(--brand-primary-10);\n}\n\n.theme-primary-light {\n  --color: var(--brand-primary-40);\n  --background-color: var(--brand-primary-10);\n  --border: none;\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--brand-primary-10);\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--brand-primary-10);\n  --color-active: var(--brand-primary-40);\n  --background-color-active: var(--brand-primary-20);\n  --color-disabled: var(--brand-primary-40);\n  --background-color-disabled: var(--brand-primary-10);\n  --border-disabled: none;\n}\n\n/*number of theme should be synced with design*/\n.theme-10 {\n  --color: var(--addition-50);\n  --color-hover: var(--addition-50);\n  --color-focus: var(--addition-50);\n  --color-active: var(--addition-50);\n  --color-disabled: var(--addition-50);\n  --background-color: var(--success-40);\n  --background-color-hover: var(--success-50);\n  --background-color-focus: var(--success-50);\n  --background-color-active: var(--success-60);\n  --background-color-disabled: var(--success-10);\n}\n\n.theme-fixed-color {\n  --color: var(--addition-50);\n  --background-color: var(--addition-110_70);\n  --border: none;\n  --color-hover: var(--addition-50);\n  --background-color-hover: var(--addition-110_80);\n  --color-focus: var(--addition-50);\n  --background-color-focus: var(--addition-110_80);\n  --color-active: var(--addition-50);\n  --background-color-active: var(--addition-110_95);\n  --color-disabled: var(--addition-50_50);\n  --background-color-disabled: var(--addition-110_70);\n  --border-disabled: none;\n}\n\n.theme-13 {\n  --color: var(--addition-80);\n  --background-color: var(--addition-50);\n  --border: none;\n  --color-hover: var(--addition-80_90);\n  --background-color-hover: var(--addition-50);\n  --color-focus: var(--addition-80_90);\n  --background-color-focus: var(--addition-50);\n  --color-active: var(--addition-80_70);\n  --background-color-active: var(--addition-50);\n  --color-disabled: var(--addition-80_70);\n  --background-color-disabled: var(--addition-50_50);\n  --border-disabled: none;\n}\n\n.theme-primary-white {\n  --color: var(--brand-primary-40);\n  --background-color: var(--addition-50);\n  --border: none;\n  --color-hover: var(--brand-primary-40);\n  --background-color-hover: var(--addition-50);\n  --color-focus: var(--brand-primary-40);\n  --background-color-focus: var(--addition-50);\n  --color-active: var(--brand-primary-40);\n  --background-color-active: var(--addition-50);\n  --color-disabled: var(--brand-primary-40_50);\n  --background-color-disabled: var(--addition-50_50);\n  --border-disabled: none;\n}\n\n.theme-secondary-white {\n  --background-color-action: color-mix(in srgb, var(--addition-40) 10%, var(--addition-50));\n\n  --color: var(--addition-40);\n  --background-color: var(--addition-50);\n  --border: none;\n  --color-hover: var(--addition-40);\n  --background-color-hover: var(--background-color-action);\n  --color-focus: var(--addition-40);\n  --background-color-focus: var(--background-color-action);\n  --color-active: var(--addition-40);\n  --background-color-active: var(--background-color-action);\n  --color-disabled: var(--addition-40_50);\n  --background-color-disabled: var(--addition-50_50);\n  --border-disabled: none;\n}\n\n.theme-16 {\n  --color: var(--base-100);\n  --background-color: var(--addition-70);\n  --border: 2px solid var(--base-30);\n  --color-hover: var(--base-100);\n  --background-color-hover: var(--addition-140);\n  --color-focus: var(--base-100);\n  --background-color-focus: var(--addition-140);\n  --color-active: var(--base-100);\n  --background-color-active: var(--base-30);\n  --color-disabled: var(--base-60);\n  --background-color-disabled: transparent;\n  --border-disabled: 2px solid var(--base-30);\n}\n\n/* synced with design CustomButton kind */\n.container.theme-primary-text {\n  --button-height: auto;\n  --button-side-offset: 0;\n  --button-text-left-offset: 0;\n  --border: none;\n  --border-disabled: none;\n  --button-border-radius: 0;\n\n  --color: var(--brand-primary-40);\n  --color-hover: var(--brand-primary-50);\n  --color-focus: var(--brand-primary-50);\n  --color-active: var(--brand-primary-60);\n  --color-disabled: var(--brand-primary-20);\n\n  --background-color: transparent;\n  --background-color-hover: transparent;\n  --background-color-focus: transparent;\n  --background-color-active: transparent;\n  --background-color-disabled: transparent;\n}\n\n.container.theme-fixed-icon {\n  --border: 2px solid var(--base-30);\n  --button-text-left-offset: 0px;\n  --border-disabled: 2px solid var(--base-30);\n\n  --color: var(--base-120);\n  --color-hover: var(--base-120);\n  --color-focus: var(--base-120);\n  --color-active: var(--base-120);\n  --color-disabled: var(--base-60);\n\n  --background-color: transparent;\n  --background-color-hover: var(--base-15);\n  --background-color-focus: var(--base-30);\n  --background-color-active: var(--base-30);\n  --background-color-disabled: transparent;\n\n  width: 100%;\n  padding-inline-end: calc(var(--button-text-left-offset) + 24px);\n}\n\n.container.theme-fixed-icon.size-20 {\n  --button-side-offset: 12px;\n}\n\n.container.theme-fixed-icon .content {\n  width: 100%;\n  justify-content: space-between;\n  text-align: center;\n}\n\n.container.theme-fixed-icon .text {\n  flex: 1;\n}\n\n.container.theme-fixed-icon .icon {\n  fill: currentColor;\n  margin-inline-end: 0;\n  width: 24px;\n}\n\n.container:disabled.theme-primary-light {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Button__container-d6909c`,
	"active": `Button__active-e40b20`,
	"content": `Button__content-f4023e`,
	"text": `Button__text-a949db`,
	"hidden": `Button__hidden-e31799`,
	"loader": `Button__loader-c30a1e`,
	"icon": `Button__icon-c31062`,
	"size-0": `Button__size-0-c8f66c`,
	"size0": `Button__size-0-c8f66c`,
	"rounding-0": `Button__rounding-0-f8cb83`,
	"rounding0": `Button__rounding-0-f8cb83`,
	"size-10": `Button__size-10-af089e`,
	"size10": `Button__size-10-af089e`,
	"size-20": `Button__size-20-b66d4e`,
	"size20": `Button__size-20-b66d4e`,
	"size-30": `Button__size-30-f6a678`,
	"size30": `Button__size-30-f6a678`,
	"rounding-1": `Button__rounding-1-bfe0c5`,
	"rounding1": `Button__rounding-1-bfe0c5`,
	"rounding-2": `Button__rounding-2-d7a7d7`,
	"rounding2": `Button__rounding-2-d7a7d7`,
	"theme-primary": `Button__theme-primary-e584ed`,
	"themePrimary": `Button__theme-primary-e584ed`,
	"theme-secondary": `Button__theme-secondary-f3364d`,
	"themeSecondary": `Button__theme-secondary-f3364d`,
	"theme-text-primary": `Button__theme-text-primary-e07c38`,
	"themeTextPrimary": `Button__theme-text-primary-e07c38`,
	"theme-text-thirty": `Button__theme-text-thirty-fb150a`,
	"themeTextThirty": `Button__theme-text-thirty-fb150a`,
	"theme-text-error": `Button__theme-text-error-ae34b3`,
	"themeTextError": `Button__theme-text-error-ae34b3`,
	"theme-text-secondary": `Button__theme-text-secondary-ec4eb8`,
	"themeTextSecondary": `Button__theme-text-secondary-ec4eb8`,
	"theme-outline-primary": `Button__theme-outline-primary-ec3b0b`,
	"themeOutlinePrimary": `Button__theme-outline-primary-ec3b0b`,
	"theme-primary-light": `Button__theme-primary-light-babd7e`,
	"themePrimaryLight": `Button__theme-primary-light-babd7e`,
	"theme-10": `Button__theme-10-ebc487`,
	"theme10": `Button__theme-10-ebc487`,
	"theme-fixed-color": `Button__theme-fixed-color-e4c76b`,
	"themeFixedColor": `Button__theme-fixed-color-e4c76b`,
	"theme-13": `Button__theme-13-e00d43`,
	"theme13": `Button__theme-13-e00d43`,
	"theme-primary-white": `Button__theme-primary-white-d21383`,
	"themePrimaryWhite": `Button__theme-primary-white-d21383`,
	"theme-secondary-white": `Button__theme-secondary-white-ef8b1f`,
	"themeSecondaryWhite": `Button__theme-secondary-white-ef8b1f`,
	"theme-16": `Button__theme-16-fd1908`,
	"theme16": `Button__theme-16-fd1908`,
	"theme-primary-text": `Button__theme-primary-text-f066dd`,
	"themePrimaryText": `Button__theme-primary-text-f066dd`,
	"theme-fixed-icon": `Button__theme-fixed-icon-cfb373`,
	"themeFixedIcon": `Button__theme-fixed-icon-cfb373`
};
module.exports = ___CSS_LOADER_EXPORT___;
